import styled from 'styled-components';

const TopNavLogo = styled.img`
   height: ${({ height }) => height};
   vertical-align: middle;
`;

TopNavLogo.defaultProps = {
   height: '40px',
};

export { TopNavLogo };
